import cx from 'classnames'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import Styles from './IntegrationCard.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import Silhouette from 'components/Previews/InstagramPreview/silhouette.jpg'
import { useConnectedAccountCardProps } from 'components/IntegrationsModal/ManageIntegrationAccounts/hooks'
import { Pressable } from '@react-aria/interactions'
import { ButtonLink } from 'blaze-ui/Button/ButtonLink'

interface Props {
  integration: ExternalIntegration
  isSelected?: boolean
  onSelect: () => void
  link?: string
}

export const IntegrationCard = ({ integration, isSelected, onSelect, link }: Props) => {
  const { name, icon, avatarUrl, details } = useConnectedAccountCardProps(integration)

  return (
    <Pressable onPress={onSelect}>
      <div className={cx(Styles.integrationCard, { [Styles.selected]: isSelected })}>
        <div className={Styles.icons}>
          <img src={avatarUrl || Silhouette} alt="profile" className={Styles.avatar} />
          {icon}
        </div>
        <div className={Styles.info}>
          <Text variant="smallList">{name}</Text>
          {details && <Text variant="label">{details}</Text>}
        </div>
        {link && (
          <ButtonLink size="xs" to={link} target="_blank" rel="noreferrer">
            View Profile
          </ButtonLink>
        )}
      </div>
    </Pressable>
  )
}
